<template>
  <div class="lh-15 c-666">
    <NavAnchor
      :is-fixed="true"
      :product-name="$t('common.productName.powersec')"
      :is-show-overview="false"
      :is-show-features="false"
      :product-url="'/product/powersec'"
    />
    <div class="content w-12r m-a">
      <h1 class="ta-c c-333">{{ $t('products.powersecspecs.title') }}</h1>
      <div class="area-1">
        <div class="area1-top">
          <img :src="pic1" alt="FJD PowerSec MP2000 " />
          <div class="text-content">
            <p class="area1-top-text1">{{ $t('products.powersecspecs.area1Text1') }}</p>
            <p class="area1-top-text2">{{ $t('products.powersecspecs.area1Text2') }}</p>
            <p class="area1-top-text3">{{ $t('products.powersecspecs.area1Text3') }}</p>
            <p class="area1-top-text4">{{ $t('products.powersecspecs.area1Text4') }}</p>
            <p class="area1-top-text5">{{ $t('products.powersecspecs.area1Text5') }}</p>
            <p class="area1-top-text6">{{ $t('products.powersecspecs.area1Text6') }}</p>
            <p class="area1-top-text7">{{ $t('products.powersecspecs.area1Text7') }}</p>
          </div>
        </div>
        <div class="area1-bottom">
          <div class="area1-bl">
            <img :src="pic2" alt="powersec" />
            <div class="text-content">
              <p class="area1-bl-text1">{{ $t('products.powersecspecs.area2Text1') }}</p>
              <p class="area1-bl-text2">{{ $t('products.powersecspecs.area2Text2') }}</p>
              <p class="area1-bl-text3">{{ $t('products.powersecspecs.area2Text3') }}</p>
              <p class="area1-bl-text4">{{ $t('products.powersecspecs.area2Text4') }}</p>
              <p class="area1-bl-text5">{{ $t('products.powersecspecs.area2Text5') }}</p>
            </div>
          </div>
          <div class="area1-br">
            <img :src="pic3" alt="powersec" />
            <div class="text-content">
              <p class="area1-br-text1">{{ $t('products.powersecspecs.area3Text1') }}</p>
              <p class="area1-br-text2">{{ $t('products.powersecspecs.area3Text2') }}</p>
              <p class="area1-br-text3">{{ $t('products.powersecspecs.area3Text3') }}</p>
              <p class="area1-br-text4">{{ $t('products.powersecspecs.area3Text4') }}</p>
              <p class="area1-br-text5">{{ $t('products.powersecspecs.area3Text5') }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- area-1:end -->
      <div class="table-content">
        <div class="cont-mod" v-for="(item, index) in specs" :key="index">
          <h2>{{ item.title }}</h2>
          <table>
            <tr v-for="(listItem, listIndex) in item.list" :key="listIndex">
              <td v-html="listItem[0]"></td>
              <td v-html="listItem[1]"></td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import NavAnchor from '@/components/NavAnchor'

  export default {
    components: {
      NavAnchor
    },
    data() {
      return {
        pic1: require('@/assets/images/powersecspec/powersecspec_img1.png'),
        pic2: require('@/assets/images/powersecspec/powersecspec_img2.png'),
        pic3: require('@/assets/images/powersecspec/powersecspec_img3.png'),
        specs: this.$t('products.powersecspecs.spces')
      }
    },
    created() {},
    methods: {}
  }
</script>

<style scoped lang="scss">
  .content {
    padding: 2rem 0 1.6rem 0;
    h1 {
      font-size: 0.48rem;
    }
    .area-1 {
      width: 12rem;
      margin: 0 auto;
      margin-top: 1rem;
    }
    .area-1 p {
      position: absolute;
      min-width: 3rem;
      font-size: 0.16rem;
      line-height: 0.22rem;
      color: rgba(51, 51, 51, 0.96);
    }

    .area1-top {
      position: relative;
      padding-top: 0.66rem;
      padding-bottom: 1.41rem;
      background-color: #f8f9fb;
    }
    .area1-top img {
      display: block;
      width: 3.44rem;
      height: 1.9rem;
      margin: 0 auto;
    }

    .area-1 p:before,
    .area-1 p:after {
      position: absolute;
      background-color: #979797;
    }
    .area-1 p:before {
      content: '';
      height: 1px;
      top: 50%;
      transform: translateY(-50%);
    }
    .area-1 p:after {
      content: '';
      width: 1px;
    }
    .area1-top-text1 {
      text-align: right;
      right: 8.8rem;
      top: 1.1rem;
    }
    .area1-top-text1:before {
      width: 1.22rem;
      left: 3.22rem;
    }
    .area1-top-text2 {
      text-align: right;
      right: 8.8rem;
      top: 1.4rem;
    }
    .area1-top-text2:before {
      width: 1.92rem;
      left: 3.22rem;
    }
    .area1-top-text3 {
      text-align: right;
      right: 8.8rem;
      top: 1.68rem;
    }
    .area1-top-text3:before {
      width: 1.8rem;
      left: 3.2rem;
    }
    .area1-top-text4 {
      left: 4.59rem;
      bottom: 0.88rem;
    }
    .area1-top-text4:after {
      height: 1.06rem;
      left: 0.98rem;
      top: -1.06rem;
    }
    .area1-top-text5 {
      left: 6.03rem;
      bottom: 0.44rem;
    }
    .area1-top-text5:after {
      height: 1.54rem;
      left: 0.17rem;
      top: -1.6rem;
    }
    .area1-top-text6 {
      left: 8.35rem;
      top: 1.45rem;
    }
    .area1-top-text6:before {
      width: 1.49rem;
      right: 3.23rem;
    }
    .area1-top-text7 {
      left: 8.35rem;
      top: 1.85rem;
    }
    .area1-top-text7:before {
      width: 1.38rem;
      right: 3.23rem;
    }

    .area1-bottom {
      display: flex;
      margin-top: 0.2rem;
    }
    .area1-bottom > div {
      width: 5.9rem;
    }
    .area1-bl {
      position: relative;
      padding: 0.57rem 0 0.66rem 0.94rem;
      margin-right: 0.2rem;
      background-color: #f8f9fb;
    }
    .area1-bl img {
      display: block;
      width: 1.92rem;
      height: 2.74rem;
    }
    .area1-bl-text1 {
      left: 2.27rem;
      top: 0.67rem;
    }
    .area1-bl-text1:before {
      width: 0.71rem;
      right: 3.12rem;
    }
    .area1-bl-text2 {
      left: 3.36rem;
      top: 1.16rem;
    }
    .area1-bl-text2:before {
      width: 1.17rem;
      right: 3.12rem;
    }
    .area1-bl-text3 {
      left: 3.36rem;
      top: 1.43rem;
    }
    .area1-bl-text3:before {
      width: 1.07rem;
      right: 3.12rem;
    }
    .area1-bl-text4 {
      left: 3.36rem;
      top: 1.72rem;
    }
    .area1-bl-text4:before {
      width: 1.31rem;
      right: 3.12rem;
    }
    .area1-bl-text5 {
      left: 3.36rem;
      top: 2.15rem;
    }
    .area1-bl-text5:before {
      width: 1.55rem;
      right: 3.12rem;
    }
    .area1-br {
      position: relative;
      padding: 0.74rem 0 0.86rem 0.41rem;
      background-color: #f8f9fb;
    }
    .area1-br img {
      display: block;
      width: 2.49rem;
      height: 2.37rem;
    }
    .area1-br-text1 {
      left: 3.54rem;
      top: 1.06rem;
    }
    .area1-br-text1:before {
      width: 1.57rem;
      right: 3.06rem;
    }
    .area1-br-text2 {
      left: 3.54rem;
      top: 1.6rem;
    }
    .area1-br-text2:before {
      width: 0.94rem;
      right: 3.06rem;
    }
    .area1-br-text3 {
      left: 3.54rem;
      top: 2.32rem;
    }
    .area1-br-text3:before {
      width: 1.04rem;
      right: 3.06rem;
    }
    .area1-br-text3:after {
      height: 0.66rem;
      right: 4.1rem;
      top: -0.54rem;
    }
    .area1-br-text4 {
      left: 3.54rem;
      top: 2.77rem;
    }
    .area1-br-text4:before {
      width: 1.16rem;
      right: 3.06rem;
    }
    .area1-br-text4:after {
      height: 0.95rem;
      right: 4.22rem;
      top: -0.83rem;
    }
    .area1-br-text5 {
      left: 3.54rem;
      top: 3.23rem;
    }
    .area1-br-text5:before {
      width: 2.46rem;
      right: 3.06rem;
    }
    .area1-br-text5:after {
      height: 1.34rem;
      right: 5.52rem;
      top: -1.22rem;
    }
    .table-content {
      overflow: hidden;
      padding-top: 1rem;
      .cont-mod {
        width: 5.64rem;
        float: left;
        table {
          width: 100%;
          margin: 0 0 0.9rem;
          td {
            padding: 0.08rem 0;
            color: #333;
          }
          td:nth-of-type(odd) {
            font-weight: 700;
          }
          td:nth-of-type(even) {
            text-align: right;
          }
        }
      }
      .cont-mod:nth-of-type(2),
      .cont-mod:nth-of-type(3) {
        margin-left: 0.7rem;
      }
      h2 {
        font-size: 0.24rem;
        color: #333;
        border-bottom: 1px solid #666;
        padding-bottom: 0.16rem;
        margin-bottom: 0.32rem;
      }
    }
  }
</style>
